<template>
  <div class="row">
    <!-- <component-loader :progress="90" :unlimitedProgress="true" v-if="!list || showLoader"></component-loader> -->
    <div class="col left">
      <div class="header">
        <div class="title">
          {{ $t('dash.inbox.title.section') }}
        </div>
        <div class="cta">
          <div class="search">
            <div class="container-svg-serach">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                    <path d="M17.0625 8.53125C17.0625 10.4139 16.4514 12.1529 15.4219 13.5639L20.6145 18.7605C21.1271 19.2732 21.1271 20.1059 20.6145 20.6186C20.1018 21.1312 19.2691 21.1312 18.7564 20.6186L13.5639 15.4219C12.1529 16.4555 10.4139 17.0625 8.53125 17.0625C3.81855 17.0625 0 13.2439 0 8.53125C0 3.81855 3.81855 0 8.53125 0C13.2439 0 17.0625 3.81855 17.0625 8.53125ZM8.53125 14.4375C9.30687 14.4375 10.0749 14.2847 10.7915 13.9879C11.5081 13.6911 12.1592 13.256 12.7076 12.7076C13.256 12.1592 13.6911 11.5081 13.9879 10.7915C14.2847 10.0749 14.4375 9.30687 14.4375 8.53125C14.4375 7.75563 14.2847 6.9876 13.9879 6.27103C13.6911 5.55445 13.256 4.90335 12.7076 4.3549C12.1592 3.80645 11.5081 3.3714 10.7915 3.07459C10.0749 2.77777 9.30687 2.625 8.53125 2.625C7.75563 2.625 6.98761 2.77777 6.27103 3.07459C5.55445 3.3714 4.90335 3.80645 4.3549 4.3549C3.80645 4.90335 3.3714 5.55445 3.07459 6.27103C2.77777 6.9876 2.625 7.75563 2.625 8.53125C2.625 9.30687 2.77777 10.0749 3.07459 10.7915C3.3714 11.5081 3.80645 12.1592 4.3549 12.7076C4.90335 13.256 5.55445 13.6911 6.27103 13.9879C6.98761 14.2847 7.75563 14.4375 8.53125 14.4375Z" fill="#AB6E93"/>
                </svg>
            </div>
            <input v-model="textFilter" :placeholder="$t('dash.placeholder.search')">           
          </div>
          <div class="btn-filter" :class="[{active: filter.type.length < 6 || filter.status.length < 4 || !filter.flag || filter.affected_to.length || filter.evaluation.length < 4}]">
            <div class="action" @click.stop="toggleFilter()">
              <i class="fa-solid fa-bars-filter"></i>

               <div class="container-filter" v-if="showFilter" @click.stop="()=>{}" ref="filterInbox">
                <div class="filter">
                  <div class="container-dates">
                
                    <div class="dates" v-if="false">
                      <input type="date" name="filterInboxDateStart" v-model="filter.dateStart" :max="(new Date).toISOString().split('T')[0]">
                      à
                      <input type="date" name="filterInboxDateEnd" v-model="filter.dateEnd" :min="filter.dateStart ? filter.dateStart :''" :max="(new Date).toISOString().split('T')[0]">
                    </div>
                  </div>
                  <div class="column border">
                    <div class="category type">
                      <div class="title-category">
                        <Checkbox :id="'addAllTypeEvent'" :isChecked="filter.type.length > 0" :isLine="filter.type.length < 6" :add="() => selectAllFilter('type')" :remove="() => removeAllFilter('type')"></Checkbox>
                        <h5>{{ $t('dash.inbox.filter.type.all') }}</h5>
                      </div>
                      <div class="list">
                        <div class="choice" v-for="value in ['message','comment','mention','rating','post','reaction']" :key="value">
                            <Checkbox :id="'type-'+value" :isChecked="filter.type.includes(value)" :add="addOptionFilter" :remove="removeOptionFilter" ></Checkbox>
                            <p>{{ $t('dash.inbox.filter.type.'+value) }}</p>
                        </div> 
                      </div>
                    </div>
                  </div>
                  <div class="column border">
                    <div class="category status">
                      <div class="title-category">
                        <Checkbox :id="'addAllStatusEvent'" :isChecked="filter.status.length > 0 || filter.flag" :isLine="filter.status.length < 4 || !filter.flag" :add="() => selectAllFilter('status')" :remove="() => removeAllFilter('status')"></Checkbox>
                        <h5>{{ $t('dash.inbox.filter.status.all') }}</h5>
                      </div>
                      <div class="list">
                        <div class="choice">
                            <Checkbox :id="'status-flag'" :isChecked="filter.flag" :add="addOptionFilter" :remove="removeOptionFilter"></Checkbox>
                            <p>{{ $t('dash.inbox.filter.status.flag') }}</p>
                        </div> 
                        <div class="choice" v-for="value in ['waiting','treated','removed','hided']" :key="value">
                            <Checkbox :id="'status-'+value" :isChecked="filter.status.includes(getTranslateFilter(value))" :add="addOptionFilter" :remove="removeOptionFilter"></Checkbox>
                            <p>{{ $t('dash.inbox.filter.status.'+value) }}</p>
                        </div> 
                      </div>
                    </div>
                  </div> 


     
                  <div class="column">
                      <div class="category evaluation">
                        <div class="title-category">
                          <Checkbox :id="'addAllEvaluationEvent'" :isChecked="filter.evaluation.length > 0" :isLine="filter.evaluation.length < 4" :add="() => selectAllFilter('evaluation')" :remove="() => removeAllFilter('evaluation')"></Checkbox>
                          <h5>{{ $t('dash.inbox.filter.evaluation.all') }}</h5>
                        </div>
                        <div class="list">
                          <div class="choice" v-for="value in ['good','normal','bad','none']" :key="value">
                            <Checkbox :id="'evaluation-'+value" :isChecked="filter.evaluation.includes(getTranslateFilter(value))" :add="addOptionFilter" :remove="removeOptionFilter"></Checkbox>
                              <div class="badge-evaluation" :class="value ">{{ $t('dash.inbox.filter.evaluation.'+value) }}</div>
                          </div> 
                        </div>
                      </div>
                      <div class="category affected_to">
                        <div class="title-category">
                          <h5>{{ $t('dash.inbox.filter.affected_to.title') }}</h5>
                        </div>
                        <div class="list">
                          <img class="image-user" v-for="(user, key) in filter.affected_to.slice(0,2)" :key="key" :src="user.avatar && user.avatar.length ? user.avatar : require('../../../assets/img/ico-man.svg')">
                            
                        
                          <i class="fa-solid fa-user-plus" @click="popupSelectUsers = true"></i>

                          <vs-popup class="overlay groups shared-planner affected_to" :title="$t('dash.inbox.filter.affected_to.popup.title')" :active.sync="popupSelectUsers">
                            <component-users-selector v-if="popupSelectUsers" :usersAdded="filter.affected_to" v-on:submit="addAffectedToFilter"></component-users-selector>
                          </vs-popup>

                        </div>
                      </div>
                  </div>
                </div>
              </div>

            </div>
           
          </div>
          <div class="reload" @click="refresh()">
            <i class="fa-solid fa-rotate-right"></i>
          </div>
        </div>
      </div>
      <component-list-inbox 
        :page="page" 
        :pages="pages" 
        :list="list"
        :totalEvents="totalEvents"
        :selected="selected"
        :textFilter="textFilter"
        :isLoading="isLoading"
        @select="selectEvent"
        @change="changeEvent"
        @changeMultiTask="changeMultiTask"
        @nextEvents="getInbox"
      ></component-list-inbox>
    </div>
    <div class="col right">
      <component-user-inbox 
        v-if="selected && selected.user"
        :user="selected.user"
        :page="pages.find(p => p.network_id == selected.page && p.network == selected.network)"
        @getActivities="getActivitiesUser"
      ></component-user-inbox>
      <component-detail-inbox 
        v-if="selected"
        :event="selected"
        :page="pages.find(p => p.network_id == selected.page && p.network == selected.network)"
        @change="changeEvent"
        @submitComment="submitComment"
        @submitLike="submitLike"
        @deleteComment="deleteComment"
        @hideComment="hideComment"
      ></component-detail-inbox>
    </div>
  </div>

  
</template>

<script>
import moment from 'moment'
import Moderation from './../../mixins/Moderation'
import Settings from './../../mixins/Settings'
import Bots from './../../mixins/Bots'
import Tooltip from './../tooltip/tooltipInit'
import PageImageAvatar from './../PageImageAvatar'
import ComponentListInbox from './ListInbox'
import ComponentUserInbox from './UserInbox'
import ComponentDetailInbox from './DetailInbox'
import ClickOutside from 'vue-click-outside'
import componentUsersSelector from './../overlay/UsersSelector.vue'
import componentLoader from './../overlay/Loader'

import Queuer from '../../../utils/Queuer'
import Checkbox from './../utils/checkbox.vue'

const translateFilter = {
  waiting : 0,
  treated : 1,
  removed : 4,
  hided : 5,

  good : 3,
  normal : 2,
  bad : 1,
  none : 0,
}

export default {
  name: 'component-inbox',

  mixins: [Moderation, Settings, Bots],

  directives: {
    ClickOutside
  },

  components: {
    Tooltip,
    PageImageAvatar,
    ComponentListInbox,
    ComponentUserInbox,
    ComponentDetailInbox,
    componentUsersSelector,
    componentLoader,
    Checkbox
  },

  props: {
    page: Object,
    pages: Array
  },

  data() {
    return {
      showLoader: false,
      list: null,
      totalEvents: 0,
      selected: null,
      filter: {
        userId: null,
        type: ["message","comment","mention","rating","post","reaction"],
        status: [0,1,4,5],
        flag: true,
        evaluation: [0,1,2,3],
        affected_to: [],
        dateStart: null,
        dateEnd: null
      },
      textFilter: '',
      showFilter: false,
      popupSelectUsers: false,
      isLoading:false,
      filterIsModified:false,
    }
  },

  async mounted() {
    this.isLoading = true
    if(localStorage.inbox_filter && JSON.parse(localStorage.inbox_filter))
      this.filter = JSON.parse(localStorage.inbox_filter)
    if(!localStorage.users)
      this.getUsers()

    await this.getInbox()
  },

   

  methods: {

    getUsers() {
      this.listUsers({}).then(res => {
        const { success, users } = res.body

        if (success !== true || 'error' in res.body) {
          return this.handleError(res)
        }

        this.users = users
        localStorage.setItem('users', JSON.stringify(this.users))
      }).catch(this.handleError)
    },

    addAffectedToFilter(users) {
      this.filter.affected_to = users
      this.popupSelectUsers = false
      this.filterIsModified = true
    },

    selectAllFilter(type) {
      console.log('selectAll', type, this.filter[type])
      if(this.filter[type].length == 0) {
        switch(type) {
          case 'type': 
            this.filter[type] = ["message","comment","mention","rating","post","reaction"]
            break
          case 'status': 
            this.filter[type] = [0, 1, 4,5]
            this.filter.flag = true
            break
          case 'evaluation': 
            this.filter[type] = [0, 1, 2, 3]
            break
        }   
      } else {
        this.filter[type] = []
        if(type == 'status')
          this.filter.flag = false
      }
      // this.$forceUpdate()
      this.filterIsModified = true
    },
    removeAllFilter(type) {
      this.filter[type] = []
      if(type == 'status') this.filter.flag = false
      // this.$forceUpdate()
      this.filterIsModified = true
    },

    addOptionFilter(typeAndOption) {
      let [type, option] = typeAndOption.split('-');
      if(type == 'status' && option == 'flag') {
        this.filter.flag = true
      }else if (type == 'type' && !this.filter[type].includes(option)){
        this.filter[type].push(option)
      }else if(!this.filter[type].includes(translateFilter[option])) {
        this.filter[type].push(translateFilter[option])
      }
      this.filterIsModified = true
    },

    removeOptionFilter(typeAndOption) {
      let [type, option] = typeAndOption.split('-');
      console.log("removeOptionFilter",type,option)
      if(type == 'status' && option == 'flag') {
        this.filter.flag = false
      }else if (type == 'type'){
        this.filter[type] = this.filter[type].filter(v => v !== option)
      }else {
        this.filter[type] = this.filter[type].filter(v => v !== translateFilter[option])
      }
      this.filterIsModified = true
    },

    getTranslateFilter(key) {
      return translateFilter[key]
    },

    toggleFilter() {
      this.showFilter ? this.closeFilter() : this.openFilter()
    },

    openFilter() {
      this.showFilter = true
      this.filterIsModified = false
      window.addEventListener('click', this.handleClickOutsideFilter);
    },

    async closeFilter() {
      this.showFilter = false
      window.removeEventListener("click", this.handleClickOutsideFilter);
      if (this.filterIsModified) {
        this.refresh()
        //localStorage.setItem('inbox_filter', JSON.stringify(this.filter))
      }
      this.filterIsModified = false
    },

    handleClickOutsideFilter(event) {
        const targetElement = this.$refs.filterInbox;
        if (!targetElement.contains(event.target)) {
            this.closeFilter()
        }
    },
   


    async deleteComment(originId, commentId) {

      let event = this.list.find(l => l._id == originId)
      let page = this.pages.find(p => p.network_id == event.page && p.network == event.network)

      await this.deleteNode(page, commentId)
      if(this.selected.network == 'instagram' && this.selected.data.changes.value.id == commentId)
        await this.changeEvent(originId, { status: 4 })
      if(this.selected.addedComments && this.selected.addedComments.length && this.selected.addedComments.find(c => c.id == commentId)) {
        let addedComments = this.selected.addedComments.filter(c => c.id != commentId)
        await this.changeEvent(originId, { addedComments })
      }
      else {
        this.list = this.list.filter(l => l._id != originId)
        this.selected = null
        this.$forceUpdate()
      }
    },

    async hideComment(event, commentId, is_hidden){

      this.showLoader = true

      // let event = this.list.find(l => l._id == originId)
      let page = this.pages.find(p => p.network_id == event.page && p.network == event.network)

      await this.hideNode(page, commentId, is_hidden)
      
      await this.changeEvent(event._id, { hide: !event.hide })
    },

    async submitComment(originId, nodeId, message) {
      this.showLoader = true

      let event = this.list.find(l => l._id == originId)
      let page = this.pages.find(p => p.network_id == event.page && p.network == event.network)

      let mediaId
      if(event.network == 'instagram' && event.type == 'mention') {
        mediaId = event.data.changes.value.media_id
        nodeId = event.data.changes.value.comment_id
      }
      
      this.addComment(page, nodeId, message, mediaId).then(async res => {
        this.showLoader = false
        const { success, comment } = res.body

        if (!success || success !== true) {
          return
        }
        
        let addedComments = []
        if(this.selected.addedComments && this.selected.addedComments.length)
        addedComments = this.selected.addedComments 
        addedComments.push({
          id: comment.id,
          message
        })
        
        await this.changeEvent(originId, { addedComments })

      })
    },

    async submitLike(originId, nodeId) {
      this.showLoader = true

      let event = this.list.find(l => l._id == originId)
      let page = this.pages.find(p => p.network_id == event.page && p.network == event.network)

      this.likeNode(page, nodeId).then(async res => {
        this.showLoader = false
        const { success, error } = res.body

        if (!success || success !== true) {
          return
        }

        addedReaction // like OR unlike 
        let addedReaction = 'like'
        if(this.selected.addedReaction && this.selected.addedReaction == 'like')
          addedReaction = 'unlike'
                
        await this.changeEvent(originId, { addedReaction })
      })
    },

    async changeEvent(id, body) {
      // this.showLoader = true

      let event = this.list.find(l => l._id == id)
      let page = this.pages.find(p => p.network_id == event.page && p.network == event.network)

      this.postInboxEvent(id, page, body).then(res => {
        console.log('resss', res)
        // this.showLoader = false
        const { success, error } = res.body

        if (!success || success !== true) {
          return
        }

        this.selected = res.body.event
        this.$set(this.list, this.list.findIndex(l => l._id == id), this.selected)
        this.$forceUpdate()
      })
    },

    async changeMultiTask(body, all=false, ids=null) {
        this.showLoader = true
      this.postInboxEvents(this.pages, body, all ? this.filter : false, !all ? ids : null).then(async res => {
        console.log('resss', res)
        this.showLoader = false
        const { success, error } = res.body

        if (!success || success !== true) {
          return
        }

        this.list = this.list.map(event => all || ids.includes(event._id) ? ({...event, ...body}) : (event))
        //await this.getInbox()
      })
    },
    
    selectEvent(event) {
      this.selected = event
      console.log('selected', this.selected)
    },

    async refresh() {


      if(this.filter.userId)
        this.filter.userId = null
      await this.getInbox()
    },

    async getActivitiesUser(user) {
      // this.filter.userId = userId
      this.filter = {
        userId: user.id,
        type: [],
        status: [],
        flag: null,
        evaluation: [],
        affected_to: []
      }
      await this.getInbox()
    },
    
    async getInbox(from = 0){

      if (from == 0) {
        this.showLoader = true
        this.isLoading = true
        this.list = []
        this.totalEvents = 0
        this.selected = null
      }
     
      this.listInboxEvents(this.pages, from, this.filter).then(res => {
  
        const { success, error } = res.body
        if (!success || success !== true) {
          return
        }

        let nextEvents = res.body.events.filter(e => !this.list.map(l => l._id).includes(e._id)) //new evite les doublon d'event
        this.list = this.list.concat(nextEvents)
        this.totalEvents += res.body.total
        this.isLoading = false

        if(this.list.length) {
          if (!this.selected) this.selected = this.list[0]

          let queue = new Queuer({
            data: JSON.parse(JSON.stringify(nextEvents)),
            task:(m) => {
              let ind = this.list.findIndex(c => c._id == m._id)
              let page = this.pages.find(p => p.network_id == m.page && p.network == m.network)
              // this.getEventMissingInfosFromRS(page.id, m.network == 'instagram' ? m.data.changes.value.comment_id || m.data.changes.value.media_id : m.userId).then((res) => {
              let type, reqId
              if(page.network == 'instagram') {
                if(m.type == 'mention') {
                  if(m.data.changes.value.comment_id) {
                    reqId = m.data.changes.value.comment_id
                    type = 'mention-comment'
                  }else if(m.data.changes.value.media_id) {
                    reqId = m.data.changes.value.media_id
                    type = 'mention-media'
                  }
                }
                else if(m.type == 'comment') {
                  // reqId = m.data.changes.value.media.id
                  reqId = m.data.changes.value.id
                  type = 'comment'
                }
                else if(m.type.includes('message')) {
                  // reqId = m.data.changes.value.media.id
                  reqId = m.data.messaging.sender.id != m.data.id ? m.data.messaging.sender.id : m.data.messaging.recipient.id
                  type = 'message'
                }
              }else {
                reqId = m.userId
              }
              console.log("getEventMissingInfosFromRS",page.id, reqId, type,m.type)
              this.getEventMissingInfosFromRS(page.id, reqId, type).then((res) => {
              
                if(res && res.body && res.body.user) {
                  this.$set(this.list[ind], 'user', res.body.user)
                  this.$forceUpdate()
                }
                else if(res && res.body && res.body.detail) {
                  this.$set(this.list[ind], 'detail', res.body.detail)
                  if(res.body.detail.mentioned_comment) {
                    this.list[ind].user = res.body.detail.mentioned_comment.from
                    this.list[ind].data.changes.value.from = res.body.detail.mentioned_comment.from
                    this.list[ind].data.changes.value.text = res.body.detail.mentioned_comment.text

                  }else if(this.list[ind].data.changes.value.from) {
                    this.list[ind].user = this.list[ind].data.changes.value.from
                  }
                  this.$forceUpdate()
                }
                else if(res && res.body && res.body.conversation) {
                  this.list[ind].user = res.body.conversation.participants.data.find(p => p.id == m.data.messaging.sender.id)
                }
                queue.unlock()
              })
            }
          })
          queue.init()
        }
  
      })
    },

  },

  watch: {
    // async pages() {
    //   console.log('watch pages', this.pages.length)
    //   await this.getInbox()
    // }, 
    pages: {
      async handler(val, oldVal){
        let refresh = val.map(v => oldVal.find(o => o.id == v.id)).find(v => !v) || val.length != oldVal.length
        if(refresh) await this.getInbox()
      },
      deep: true
    },
    ['filter.dateStart']() {
      this.filterIsModified = true
    },
    ['filter.dateEnd']() {
      this.filterIsModified = true
    },

    // filter: {
    //   async handler(val, oldVal){
    //     await this.getInbox()
    //     localStorage.setItem('inbox_filter', JSON.stringify(val))
    //   },
    //   deep: true
    // },

    selected() {
      this.closeFilter()
    }
  },

  beforeDestroy() {
    window.removeEventListener("click", this.handleClickOutsideFilter);
  },

}    
</script>